// Copyright 1999-2017. Plesk International GmbH. All rights reserved.
/* eslint-disable react/prefer-stateless-function */

import { createElement, Component } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import FormField from '../FormField';
import Input from '../Input';

import './FormFieldText.less';

/**
 * `FormFieldText` component.
 */
class FormFieldText extends Component {
    render() {
        const {
            baseClassName,
            className,
            size,
            placeholder,
            disabled,
            ...props
        } = this.props;

        return (
            <FormField className={classNames(baseClassName, className)} {...props}>
                {({ getId, getName, getValue, setValue }) => (
                    <Input
                        id={getId()}
                        name={getName()}
                        className={`${baseClassName}__input`}
                        value={getValue('')}
                        onChange={e => setValue(e.target.value)}
                        disabled={disabled}
                        size={size}
                        placeholder={placeholder}
                    />
                )}
            </FormField>
        );
    }
}
FormFieldText.propTypes = {
    /**
     * Size of the input
     */
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'fill']),
    /**
     * Placeholder of the input
     */
    placeholder: PropTypes.string,
    /**
     * Disabled state of field.
     */
    disabled: PropTypes.bool,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
FormFieldText.defaultProps = {
    size: undefined,
    placeholder: undefined,
    disabled: false,
    className: undefined,
    baseClassName: `${CLS_PREFIX}form-field-text`,
};

export default FormFieldText;



// WEBPACK FOOTER //
// ./components/FormFieldText/FormFieldText.js